/*@ngInject*/
const AcknowledgeModificationsRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.acknowledgeModifications = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/acknowlegeModifications';

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('acknowledgeModificationsRepository', AcknowledgeModificationsRepository);
